import React from 'react';
import {useParams} from 'react-router-dom';
import FormModal from "components/modals/FormModal";
import {InputText} from "primereact/inputtext";
import _ from "lodash";
import {Calendar} from "primereact/calendar";
import {useCreateKpiTaskMutation, useGetKpiTaskQuery, useUpdateKpiTaskMutation} from "../../apis/kpiApi";
import TaskResponsibleDropdown from "../../components/dropdowns/TaskResponsibleDropdown";
import { defaultTaskValidator } from 'validators/TaskValidators';

const KPITaskModal = () => {
    const { task, target, parentTask } = useParams();
    const {data: editPriorityTask, isFetching} = useGetKpiTaskQuery(task);
    const queryParentTask = parentTask || editPriorityTask?.parentTask;
    const {data: parentTaskData, isParentTaskFetching} = useGetKpiTaskQuery(queryParentTask, {skip: !queryParentTask});

    
    const [createKpiTask] = useCreateKpiTaskMutation();
    const [updateKpiTask] = useUpdateKpiTaskMutation();

    const handleSubmit = (data) => {
        const clonedData = _.cloneDeep(data);

        clonedData.deadline = data.deadline.getTime();

        if(!clonedData.id || clonedData.id === 'new') {
            clonedData.parent = target;
            if(parentTask) {
                clonedData.parentTask = parentTask;
            }
            createKpiTask(clonedData);
        }
        else {
            updateKpiTask(clonedData)
        }
    }

   
    if(isFetching || isParentTaskFetching) {
        return (<></>);
    }
    else {
        const clonedTask = _.cloneDeep(editPriorityTask);

        clonedTask.deadline = clonedTask.deadline < 1000 ? new Date() : new Date(clonedTask.deadline);

        return (<FormModal type={parentTaskData? `KPI Subtask (Parent Task: ${parentTaskData?.name})` : "KPI Task"} editObject={clonedTask || {name: ''}} handleSubmit={handleSubmit} validationSchema={defaultTaskValidator}
            renderForm={(formik) =>
                (<form onSubmit={formik.handleSubmit} className="formgrid grid">
                    <div className="field col-12">
                        <span className="p-float-label">
                            <InputText id="name" name="name" className="inputfield w-full" value={formik.values?.name} onChange={formik.handleChange} autoFocus />
                            <label htmlFor="name">Task Name</label>
                        </span>
                        {formik.errors.name && formik.touched.name ? (
                                <span className="error form-error">{formik.errors.name}</span>
                        ) : null}
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <TaskResponsibleDropdown name="responsible" id="responsible" className="w-4" value={formik.values?.responsible === '' ? undefined : formik.values?.responsible} 
                                      onChange={formik.handleChange} parentTask={parentTaskData} />
                            <label htmlFor="responsible">Responsible</label>
                        </span>
                        {formik.errors.responsible && formik.touched.responsible ? (
                                <span className="error form-error">{formik.errors.responsible}</span>
                        ) : null}
                    </div>
                    <div className="field col-12">
                        <span className="p-float-label">
                            <Calendar className="w-4" name="deadline" value={formik.values?.deadline} onChange={formik.handleChange} showIcon />
                            <label htmlFor="deadline">Deadline</label>
                        </span>
                        {formik.errors.deadline && formik.touched.deadline ? (
                                <span className="error form-error">{formik.errors.deadline}</span>
                        ) : null}
                    </div>
                </form>)
            }>
        </FormModal>)
    }
}

export default KPITaskModal;
